import { render, staticRenderFns } from "./CompRemunerationVideo.vue?vue&type=template&id=532bf5e0&scoped=true"
import script from "./CompRemunerationVideo.vue?vue&type=script&setup=true&lang=js"
export * from "./CompRemunerationVideo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CompRemunerationVideo.vue?vue&type=style&index=0&id=532bf5e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532bf5e0",
  null
  
)

export default component.exports